/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Level_PlaceholderInputs */

const en_level_placeholder = /** @type {(inputs: Level_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Level`)
};

const de_level_placeholder = /** @type {(inputs: Level_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau`)
};

/**
* | output |
* | --- |
* | "Level" |
*
* @param {Level_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const level_placeholder = /** @type {((inputs?: Level_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_level_placeholder(inputs)
	return en_level_placeholder(inputs)
});